module.exports = __webpack_public_path__ + "static/media/slugman.0f3a3202.png";